/**
 * BrandMark — Crit Roster signet (the slanted "C" with text lines)
 * Props:
 *   size    — rendered pixel size (default 28)
 *   variant — 'cyan'     dark bg, full Signal Cyan (#00DBE9)
 *             'on-light' light bg, AA-compliant cyan (#00A8B4)
 *             'white'    dark bg, mono white
 *   style   — extra inline style overrides on the <svg>
 */
export default function BrandMark({ size = 28, variant = 'cyan', style = {} }) {
  const stroke = variant === 'on-light' ? '#00A8B4'
               : variant === 'white'    ? '#F2F6F7'
               :                         '#00DBE9';
  const fill   = variant === 'on-light' ? '#0A0F12' : '#F2F6F7';

  // ≤ 40px: favicon proportions — 2 thicker bars, heavier stroke, stays readable
  // >  40px: full 3-bar display mark
  const small = size <= 40;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      width={size}
      height={size}
      fill="none"
      style={{ display: 'block', flexShrink: 0, ...style }}
      aria-label="Crit Roster"
      role="img"
    >
      <g transform="skewX(-8) translate(6 0)">
        <path
          d="M70 16 H40 A24 24 0 0 0 16 40 V60 A24 24 0 0 0 40 84 H70"
          stroke={stroke}
          strokeWidth={small ? 19 : 15}
          strokeLinecap="round"
          fill="none"
        />
        {small ? (
          <>
            <rect x="36" y="41" width="46" height="11" rx="5.5" fill={fill} />
            <rect x="36" y="58" width="28" height="11" rx="5.5" fill={fill} opacity="0.55" />
          </>
        ) : (
          <>
            <rect x="36" y="38" width="48" height="7" rx="3.5" fill={fill} />
            <rect x="36" y="50" width="34" height="7" rx="3.5" fill={fill} opacity="0.55" />
            <rect x="36" y="62" width="22" height="7" rx="3.5" fill={fill} opacity="0.3" />
          </>
        )}
      </g>
    </svg>
  );
}
